import gsap from "gsap";
import _ from "underscore";
import ProjectUtil from "./project-util";
import Timer from "./timer";

class BackboneSlider {
	// Slider Namespace
	// --------------------------

	// Helpers
	// --------------------


	// Backbone.View Mixins
	// --------------------
	constructor() {
		// Export onto Backbone object
		//Backbone.Slider = Slider;
	}
	/**
	 * Events
	 */
	// extend events
	events() {
		return {
			'click .slider-left-btn': 'sli_handleLeftBtnClick',
			'click .slider-right-btn': 'sli_handleRightBtnClick',
			// swipe stuff
			'dragstart .slides-holder a': 'sli_handleSwipeAction',
			'touchstart .slides-holder': 'sli_handleSwipeAction',
			'mousedown .slides-holder': 'sli_handleSwipeAction',
			'touchmove .slides-holder': 'sli_handleSwipeAction',
			'mousemove .slides-holder': 'sli_handleSwipeAction',
			'touchend .slides-holder': 'sli_handleSwipeAction',
			'mouseup .slides-holder': 'sli_handleSwipeAction',
			'touchcancel .slides-holder': 'sli_handleSwipeAction',
			'mouseleave .slides-holder': 'sli_handleSwipeAction',
			'click .slides-holder': 'sli_handleSlidesHolderClick',
			'click .slider-indicators-list button': 'sli_handleIndicatorClick',
			//'focus .slider-item': 'sli_handleSliderItemFocus',
		};
	}
	/**
	 * Initialize the Slider
	 */
	initSlider(configObj) {
		//console.log('[Backbone.Slider].initSlider', configObj, this);
		var self = this,
			config = {
				dispatchEvents: true,
				useArrows: true, // if false, no arrows will be used, regardless of settings in columnSizingAr.
				useSwipe: true, // if false, swiping will not work for the gallery
				outerMargin: 0,
				defaultEnabled: true,
				dragEnabled: true,
				defaultColumns: 1,
				defaultHandleFocus: true,
				slidePosition: 'center',
				looping: false,
				autoPlay: false,
				autoPlayTime: 4,
				namespace: 'slider-' + Math.floor(Math.random() * 100000), // you should assign a namespace, but this should help prevent collisions
				columnSizingAr: [
					{
						minRes: 0,
						itemLeftPadding: 10,
						numColumns: 1,
						useArrows: false,
					},
				],
				defaultPadding: 10,
				defaultLeftMargin: 0,
			};

		// define this config by extending default settings with input settings
		this.sli_config = $.extend(config, configObj);

		// jquery elements
		this.$sli_items = $('.slider-item', this.$el); // the original slides.  Do not add/remove from this.
		this.$sli_arrows = $('.slider-left-btn, .slider-right-btn', this.$el);
		this.$sli_prevBtn = $('.slider-left-btn', this.$el);
		this.$sli_nextBtn = $('.slider-right-btn', this.$el);
		this.$sli_sliderIndicatorsList = $('.slider-indicators-list', this.$el);
		this.$sli_indicators = $('li', this.$sli_sliderIndicatorsList);
		this.$sli_firstItem = this.$sli_items.first();
		this.$sli_lastItem = this.$sli_items.last();
		this.$sli_slidesWrap = $('.slides-wrap', this.$el);
		this.$sli_slidesHolder = $('.slides-holder', this.$el);

		// paramaeters
		// the index of the last slider item
		this.sli_lastItemIndex = this.$sli_items.index(this.$sli_lastItem);
		// total number of slider items, excluding duplicates
		this.sli_totalItems = this.$sli_items.length;
		// total number of slider items, including duplicates (updated later, after duplicate creation and insertion)
		this.sli_totalItemsWithDuplicates = this.$sli_items.length;
		// the padding on each slider item
		this.sli_padding = this.sli_getPadding();
		// the outer margin on the containing element
		this.sli_outerMargin = this.sli_config.outerMargin;
		// allow for setting aria-hidden on items
		this.setAriaHidden = true;
		// slides holder as DOM element
		this.sli_slidesHolder = (this.$sli_slidesHolder.length) ? this.$sli_slidesHolder[0] : null;
		// positioning data object for slides holder (the element that actually moves)
		this.sli_slidesHolderObj = { $slidesHolder: this.$sli_slidesHolder, slidesHolder: this.sli_slidesHolder, dest: 0 };
		// width of slides wrap - updated on resize
		this.sli_slidesWrapWidth = 0;
		// the index of the currently displayed page
		this.sli_activePage = 0;
		// the active config obj, based on minRes value
		this.curColumnSizingObj = this.sli_getCurColumnSizingObj();
		// boolean that there currenlty exists a columnSizingObj - resets to false on resize
		this.curColumnSizingObjSet = true;
		// current number of columns on the page
		this.sli_numColumns = this.sli_getNumColumns();
		// total number of pages
		this.sli_totalPages = Math.ceil(this.sli_totalItems / this.sli_numColumns);
		// object for managing touch interactions
		this.sli_touchObject = {};
		// timeout for setting focus on element
		this.focusTimeout = null;

		// create Array of sli_item Objects.  TODO: This was to support looping, not currently acive - evaluate need for this
		this.sli_itemsAr = [];
		_.each(this.$sli_items, function (item, index) {
			self.sli_itemsAr.push({ $item: $(item), index: index, dest: 0 });
		});

		this.sli_slidesWrapWidth = this.$sli_slidesWrap.width() + this.sli_getLeftPadding();
		//console.log('[SliderBaseView].$sli_slidesWrap.width(): ', this.$sli_slidesWrap.width(), this.cid, this);
		//console.log('[SliderBaseView].this.sli_slidesWrapWidth 1: ' + this.$sli_slidesWrap.width() + ' + ' + this.sli_getLeftPadding() + ' = ' + this.sli_slidesWrapWidth);

		if (this.sli_config.looping) {
			// duplicate slides for looping
			var numDuplicated = 0, // number of items to duplicate on each side of the slider
				total = this.sli_config.columnSizingAr.length,
				i;

			for (i = 0; i < total; i++) {
				if (this.sli_config.columnSizingAr[i].numColumns + 1 > numDuplicated) {
					numDuplicated = this.sli_config.columnSizingAr[i].numColumns;
				}
			}
			// make sure numDuplicated isn't larger than total items
			numDuplicated = Math.min(numDuplicated, total);

			// prepend the last [numDuplicated] items at the beginning, and the first [numDuplicated] itesm at the end
			var $end = $('<div>').append(this.$sli_items.slice(-numDuplicated).clone());
			$('.slider-item', $end).addClass('duplicate end');
			var $start = $('<div>').append(this.$sli_items.slice(0, numDuplicated).clone());
			$('.slider-item', $start).addClass('duplicate start');
			this.$sli_slidesHolder.prepend($end.html()).append($start.html());

			// try this _WITH_updating $sli_items to see if this works better
			this.$sli_items = $('.slider-item', this.$el);
			// add updated items to array
			_.each($('.duplicate.end', this.$sli_slidesHolder), function (item, index) {
				// these items are duplicated at the beginning.  subtract (index + 1) from 0.
				self.sli_itemsAr.unshift({ $item: $(item), index: 0 - (index + 1), dest: 0 });
			});
			_.each($('.duplicate.start', this.$sli_slidesHolder), function (item, index) {
				// these items are duplicated at the end.  add index to sli_totalItems
				self.sli_itemsAr.push({ $item: $(item), index: self.sli_totalItems + index, dest: 0 });
			});
			//this.sli_totalItems = this.$sli_items.length;
			this.sli_totalItemsWithDuplicates = this.$sli_items.length;
		}

		$(window).on('resize.' + self.sli_config.namespace + ' orientationchange.' + self.sli_config.namespace, function () {
			self.sli_resize();
		});

		/* this happens with resize anyway
		if (this.sli_useSlider()) {
			// create the indicator dots
			this.sli_createIndicators();
			// force dest positions to be set
			this.sli_setDestPositions();
			// put everything into place
			this.sli_moveItems(false);
		}
		*/

		// start timer
		if (this.sli_config.autoPlay) {
			this.sli_resetTimer();
		}

		// check that images are loaded on an interval, update hieght if so, stop checking once all are ready
		this.sli_checkImagesLoaded(); // this triggers resize

		// ready
		this.$el.addClass('ready');
		// trigger resize functionality now
		//this.sli_resize(); // resize triggered by sli_checkImagesLoaded, not necessary here
	}

	/**
	 * Set a specific slide to 'active' based on the index
	 * @param tSlideIndex The index of the slide to make active
	 * @param focusEvent if this function is triggered from a focus Event (sli_handleSliderItemFocus)
	 */
	setActiveSlide(tSlideIndex, focusEvent) {
		//console.log('[SliderBaseView].setActiveSlide', tSlideIndex, focusEvent);
		// require enabled
		if (!this.sli_getEnabled()) { return; }

		focusEvent = (focusEvent === undefined) ? false : true;

		var self = this,
			tSizingObj = this.sli_getCurColumnSizingObj(),
			tExternallyTriggered = !focusEvent;


		// determine if numColumns > 1, and the clicked slide is on the next to last page
		if (tSizingObj.numColumns > 1 && this.sli_activePage === this.sli_totalPages - 1) {
			//determine if the slide at tSlideIndex is in the right column
			var tColumn = tSlideIndex % tSizingObj.numColumns;
			if (tColumn === tSizingObj.numColumns - 1) {
				// get out of here
				// I expect this to get all slides on the next to last page, which is wrong
				//console.log('[SliderBaseView].setActiveSlide - the last page is active, but the focused slide is visible but technically on the previous page');
				return;
			}
		}

		/* 
		standard handling - this works almost always, but if the last page has a single 'slide',
		and a fully-visible slide from the previous page is clicked, then this will animate to 
		that page instead of handling the click as expected.
		*/
		this.sli_activePage = Math.floor(tSlideIndex / tSizingObj.numColumns);

		if (!this.sli_config.looping) {
			// put limits on sli_activePage
			if (this.sli_activePage >= this.sli_totalPages - 1) {
				// upper limit
				this.sli_activePage = this.sli_totalPages - 1;
				// hide next button
				gsap.to(this.$sli_nextBtn, 0.3, { autoAlpha: 0, display: 'none' });
			} else if (this.sli_activePage <= 0) {
				// lower limit
				this.sli_activePage = 0;
				// hide prev button
				gsap.to(this.$sli_prevBtn, 0.3, { autoAlpha: 0, display: 'none' });
			}
		}

		// update positions and move items.
		this.sli_setDestPositions(tExternallyTriggered);
		this.sli_moveItems();
		this.sli_resetTimer();
		ProjectUtil.onNextFrame(function () {
			self.sli_swipeEnd();
		});

	}

	/**
	 * Clear and reset the autoPlay timer
	 */
	sli_resetTimer() {
		if (this.sli_config.autoPlay) {

			var self = this;
			if (this.timer) {
				// reset the timer if it already exists
				this.timer.restart();
			} else {
				// start the timer and define the timer actions
				this.timer = new Timer(function () {
					self.sli_handleRightBtnClick(null, true);
				},
					{
						delay: self.sli_config.autoPlayTime * 1000,
						repeat: 99999,
					}); // autoPlay time (in ms), 99999 repeoat count
			}
		}
	}

	/**
	 * Pause the autoPlay Timer
	 */
	sli_pauseAutoPlay() {
		if (this.sli_config.autoPlay) {
			if (this.timer) {
				this.timer.pause();
			}
		}
	}

	/**
	 * Resume the autoPlay Timer
	 */
	sli_resumeAutoPlay() {
		if (this.sli_config.autoPlay) {
			if (this.timer) {
				this.timer.resume();
			}
		}
	}

	/**
	 * Store reference to the current column sizing Object
	 */
	sli_getCurColumnSizingObj() {
		// update this.curColumnSizingObj if necessary
		if (!this.curColumnSizingObjSet) {
			// the page has resized, determine and store current column sizing Object
			var tAr = this.sli_config.columnSizingAr,
				total = tAr.length,
				i;

			for (i = 0; i < total; i++) {
				if (ProjectUtil.viewportGTE(tAr[i].minRes)) {
					this.curColumnSizingObj = tAr[i];
					this.curColumnSizingObjSet = true;
					break;
				}
			}
		}
		return this.curColumnSizingObj;
	}

	/**
	 * dispatch an inactive update, if defined
	 */
	sli_dispatchInactiveEvent($items) {
		var tSizingObj = this.sli_getCurColumnSizingObj();
		if ($items.length && tSizingObj.hasOwnProperty('inactiveEvent')) {
			//console.log('[SliderBaseView].sli_dispatchInactiveEvent: ', $items);
			this.pubSub.trigger(tSizingObj.inactiveEvent, $items, this.sli_config.namespace);
		}
	}

	/**
	 * dispatch an active update, if defined
	 */
	sli_dispatchActiveEvent($items, tExternallyTriggered) {
		var tSizingObj = this.sli_getCurColumnSizingObj();
		if ($items.length && tSizingObj.hasOwnProperty('activeEvent')) {
			this.pubSub.trigger(tSizingObj.activeEvent, $items, this.sli_config.namespace, tExternallyTriggered);
		}
	}

	/**
	 * Get the current left padding on the first item
	 */
	sli_getLeftPadding() {
		return parseInt(this.$sli_firstItem.css('paddingLeft'), 10);
	}

	/**
	 * Get a config vaule for current config
	 */
	sli_getConfigValue(tCheckActive, tValue, tDefault) {
		if (tCheckActive) {
			var tSizingObj = this.sli_getCurColumnSizingObj();
			if (tSizingObj.hasOwnProperty(tValue)) {
				return tSizingObj[tValue];
			}
		}
		// not using arrows
		return tDefault;
	}

	/**
	 * get itemLeftPadding for current config
	 */
	sli_getPadding() {
		return this.sli_getConfigValue(true, 'itemLeftPadding', 0);
	}

	/**
	 * Get Left Margin of slides-holder
	 */
	sli_getLeftMargin() {
		return this.sli_getConfigValue(true, 'holderLeftMargin', 0);
	}

	/**
	 * get useArrows for current config.
	 * Arrows can be disabled per slider, overriding individual column sizing settings
	 */
	sli_getShowArrows() {
		return this.sli_getConfigValue(this.sli_config.useArrows, 'useArrows', false);
	}

	/**
	 * get dragEnabled for current config.
	 * dragEnabled can be disabled per slider, overriding individual column sizing settings
	 */
	sli_getDragEnabled() {
		return this.sli_getConfigValue(/*this.sli_config.dragEnabled*/ true, 'dragEnabled', true);
	}

	/**
	 * check that all images are loaded
	 */
	sli_checkImagesLoaded() {
		var self = this,
			$images = $('img', this.$el),
			loaded = true;

		_.each($images, function (tImg) {
			if (tImg.complete !== true) {
				loaded = false;
			}
		});

		if (!loaded) {
			setTimeout(function () {
				self.sli_checkImagesLoaded();
			}, 500);
		}
		// trigger resize functionality now
		this.sli_resize();
	}

	/**
	 * Default to showing indicators if there is a dest for them
	 */
	sli_getShowIndicators() {
		if (this.$sli_sliderIndicatorsList.length) {
			return true;
		}
		return false;
	}

	/**
	 * Determine if the slider is enabled at this size.  Default is true.
	 */
	sli_getEnabled() {
		/*var tSizingObj = this.sli_getCurColumnSizingObj();
		if (tSizingObj.hasOwnProperty('enabled')) {
			return tSizingObj.enabled;
		}
		
		// no match was found - use default
		return this.sli_config.defaultEnabled;*/
		return this.sli_getConfigValue(true, 'enabled', this.sli_config.defaultEnabled);
	}

	/**
	 * Override these values to change number of columns at different sizes
	 */
	sli_getNumColumns() {
		/*var tSizingObj = this.sli_getCurColumnSizingObj();
		if (tSizingObj.hasOwnProperty('numColumns')) {
			console.log('[SliderBaseView].setting sli_numColumns: ', tSizingObj.numColumns, this.cid, tSizingObj);
			return tSizingObj.numColumns;
		}

		// no match was found - use default
		return this.sli_config.defaultColumns;*/
		return this.sli_getConfigValue(true, 'numColumns', this.sli_config.defaultColumns);
	}

	/**
	 * Override focus handling [by blocking it]
	 */
	sli_getHandleFocus() {
		return this.sli_getConfigValue(true, 'handleFocus', this.sli_config.defaultHandleFocus);
	}

	/**
	 * Override this to alter resize based on specific resolutions
	 * TODO: This function, and references to it, can probalby be removed.
	 */
	sli_useSlider() {
		return true;
	}

	/**
	 * 
	 */
	sli_resize() {
		if (!this.sli_useSlider()) { return; } //allow resize to be overridden
		//console.log('[SliderBaseView].sli_resize');
		// if this is in an expander, make sure it's not display:none so these calcs work
		var $expandDetails = this.$el.closest('.expanded-details');
		$expandDetails.addClass('show');
		// no longer necessarily using the correct curColumnSizingObj
		this.curColumnSizingObjSet = false;
		// check if manageAriaHidden is set to false, and if this is new
		if (this.sli_getConfigValue(true, 'manageAriaHidden', true) === false && this.setAriaHidden) {
			//console.log('[SliderBaseView].sli_resize - manageAriaHidden is false, and setAriaHidden is true');
			// unset aria-hidden on all items
			this.sli_setAriaHiddenState(this.$sli_items, false); // false to show
			// update this.setAriaHidden
		}
		this.setAriaHidden = this.sli_getConfigValue(true, 'manageAriaHidden', true);
		this.enabled = this.sli_getEnabled();
		// update position vars
		this.sli_padding = this.sli_getLeftPadding();
		this.sli_padding = this.sli_getPadding();
		this.sli_numColumns = this.sli_getNumColumns();
		this.sli_totalPages = Math.ceil(this.sli_totalItems / this.sli_numColumns);
		this.sli_slidesWrapWidth = this.$sli_slidesWrap.width() + this.sli_getLeftPadding();
		//console.log('[SliderBaseView].this.sli_slidesWrapWidth 2: ' + this.$sli_slidesWrap.width() + ' + ' + this.sli_getLeftPadding() + ' = ' + this.sli_slidesWrapWidth);
		//console.log('[SliderBaseView].sli_resize::.$sli_slidesWrap.width(): ', this.$sli_slidesWrap.width(), this.cid, this);
		if (this.sli_activePage >= this.sli_totalPages) {
			this.sli_activePage = this.sli_totalPages - 1;
		}
		// create the indicator dots
		this.sli_createIndicators();
		//console.log('[SliderBaseView].sli_resize - calling sli_setDestPositions');
		// set dest positions
		this.sli_setDestPositions();
		//move items into new position
		this.sli_moveItems(false);
		// update arrows
		this.sli_showArrows();
		$expandDetails.removeClass('show');
	}

	/**
	 * Create the gallery indicators
	 */
	sli_createIndicators() {
		//console.log('[SliderBaseView].sli_createIndicators: ', this.sli_getShowIndicators());
		if (this.sli_getShowIndicators()) {
			// we are using indicators, so create them
			var tHtml = '',
				i;
			for (i = 0; i < this.sli_totalPages; i++) {
				tHtml += '<li><button data-index="' + i + '"></button></li>';
			}
			this.$sli_sliderIndicatorsList.html(tHtml);
			this.$sli_indicators = $('li', this.$sli_sliderIndicatorsList);
		}
	}

	/**
	 * Dispatch events, if that's requested
	 */
	sli_dispatchEvent(name, paramsObj) {
		if (this.sli_config.dispatchEvents) {
			//console.log('[SliderBaseView].dispatching event: ', name, paramsObj);
			this.pubSub.trigger(name, paramsObj);
		}
	}

	/**
	 * Set aria-hidden attribute on all items
	 * @param $target The target item to set active state
	 * @param tHide If true, set aria-hidden to true, else set to false
	 */
	sli_setAriaHiddenState($target, tHide) {
		var tAriaHidden = tHide ? 'true' : 'false',
			tTabIndex = tHide ? '-1' : '0';

		$target.removeClass('active').attr('aria-hidden', tAriaHidden).attr('tabindex', tTabIndex);
		// also set links in content tabindex to tTabIndex
		$('.desc a', $target).attr('tabindex', tTabIndex);
		// also set post-content-btn and post-image-btn tabindex to tTabIndex
		$('.post-content-btn, .post-image-btn, .video-modal-btn, .person-content-btn, .marquee-item-content.btn, .social-post-image-btn', $target).attr('tabindex', tTabIndex);
		// also set 'more' button to tabindex tTabIndex
		$('.btn-wrap .btn, .cta-wrap .btn', $target).attr('tabindex', tTabIndex);
	}

	/**
	 * Set the positions for items to animate to.
	 * @param tExternallyTriggered If the event was triggered by an external call (vs swipe/button click)
	 * @param tSetFocus If the event should set focus on the active slide (from a button click)
	 */
	sli_setDestPositions(tExternallyTriggered, tSetFocus) {
		tExternallyTriggered = (tExternallyTriggered !== undefined) ? tExternallyTriggered : false;
		tSetFocus = (tSetFocus !== undefined) ? tSetFocus : false;

		// require enabled
		if (!this.sli_getEnabled() || !this.sli_useSlider()) { return; }

		var self = this,
			itemWidth,
			tPageWidth,
			tPagePositioning,
			tManageAriaHidden = this.sli_getConfigValue(true, 'manageAriaHidden', true),
			i = 0;

		// remove active class from active slides
		this.sli_dispatchInactiveEvent($('.active', this.$sli_slidesHolder));
		if (tManageAriaHidden !== false) {
			// update aria-hidden and tabindex on all items
			this.sli_setAriaHiddenState(this.$sli_items, true); // true to hide
		} else {
			// Only remove active class from active slides
			this.$sli_items.removeClass('active');
		}

		// get the width of an item, using the first item, including padding and border
		itemWidth = this.$sli_firstItem.outerWidth();

		if (this.sli_activePage === 0) {
			// First Page - align item on the left (w/ padding)
			this.sli_slidesHolderObj.dest = 0;
			// check for fillCount value, compared to sli_numColumns.  If equal or below, make all sli_items have tabindex 0
			if (this.sli_getConfigValue(true, 'fillCount', 0) >= this.sli_totalItems) {
				if (tManageAriaHidden !== false) {
					// update aria-hidden and tabindex on all items
					this.sli_setAriaHiddenState(this.$sli_items, false); // false to show
				} else {
					// all items are visible, make all items active
					this.$sli_items.addClass('active');
				}
			} else {
				// not all items are visible, so set active class to each slider item on the page
				// add active class to each slider item on the page
				while (i < this.sli_numColumns) {
					if (tManageAriaHidden !== false) {
						// update aria-hidden and tabindex on this item
						this.sli_setAriaHiddenState(this.$sli_items.eq(i), false); // false to show
					} else {
						// only set this item's active class
						this.$sli_items.eq(i).addClass('active');
					}
					i++;
				}
			} // end fillCount check

			// set focus?
			if (tSetFocus) {
				//console.log('set focus: ', 0, this.$sli_items.eq(0));
				// clear pre-exisitng focus timeout
				clearTimeout(this.focusTimeout);
				// set focus when tween is complete
				this.focusTimeout = setTimeout(function () {
					self.$sli_items.eq(0).focus();
				}, 310);
			}

		} else if (this.sli_activePage >= this.sli_totalPages - 1) {
			// Last Page - align item on the right (w/ padding)
			var itemsOnLastPage = this.sli_totalItems % this.sli_numColumns || this.sli_numColumns;
			//console.log('[SliderBaseView].itemsOnLastPage: ' + this.sli_totalItems + ' % ' + this.sli_numColumns + ' || ' + this.sli_numColumns + ' = ' + itemsOnLastPage);

			tPageWidth = (itemWidth + self.sli_padding) * self.sli_numColumns;
			//console.log('[SliderBaseView].tPageWidth: (' + itemWidth + ' + ' + self.sli_padding + ') * ' + this.sli_numColumns + ' = ' + tPageWidth);
			tPagePositioning = self.sli_slidesWrapWidth - (itemWidth + self.sli_padding) * itemsOnLastPage;
			//console.log('[SliderBaseView].tPagePositioning: ' + self.sli_slidesWrapWidth + ' - (' + itemWidth + ' + ' + self.sli_padding + ') * ' + itemsOnLastPage + ' = ' + tPagePositioning);

			this.sli_slidesHolderObj.dest = tPagePositioning + (-self.sli_activePage * tPageWidth + self.sli_padding) - self.sli_getLeftMargin();

			// add active class to each slider item on the page
			//console.log('[SliderBaseView].set active for last page');
			i = this.$sli_items.length - 1;
			while (i > this.$sli_items.length - 1 - this.sli_numColumns) {
				//console.log('[SliderBaseView].2.set active: ', i);
				//this.$sli_items.eq(i).addClass('active');
				if (tManageAriaHidden !== false) {
					// update aria-hidden and tabindex on this item
					this.sli_setAriaHiddenState(this.$sli_items.eq(i), false); // false to show
				} else {
					// only set this item's active class
					this.$sli_items.eq(i).addClass('active');
				}
				i--;
			}
			// set focus?
			if (tSetFocus) {
				//console.log('set focus: ',(this.$sli_items.length - 1), this.$sli_items.eq(this.$sli_items.length - 1));
				// clear pre-exisitng focus timeout
				clearTimeout(this.focusTimeout);
				// set focus when tween is complete
				this.focusTimeout = setTimeout(function () {
					self.$sli_items.eq(self.$sli_items.length - 1).focus();
				}, 310);
			}
		} else {
			// Middle Page - pages with prev and next
			if (this.sli_config.slidePosition === 'center') {
				tPageWidth = (itemWidth + self.sli_padding) * self.sli_numColumns;
				tPagePositioning = self.sli_slidesWrapWidth / 2 - tPageWidth / 2 + self.sli_padding / 2;

				// center the content - half the container width minus half the page width, plus half the padding
				// page's position in list of pages * width of a page
				// plus the item's position in the page
				this.sli_slidesHolderObj.dest = tPagePositioning + (-self.sli_activePage * tPageWidth) - self.sli_padding / 2 - self.sli_getLeftMargin();
			} else if (this.sli_config.slidePosition === 'left') {

				// TODO: HANDLE THIS
				// TEMP
				this.sli_slidesHolderObj.dest = 0;
			}
			// add active class to each slider item on the page
			i = this.sli_numColumns * this.sli_activePage;
			while (i < this.sli_numColumns * (this.sli_activePage + 1)) {
				//console.log('[SliderBaseView].3.set active: ', i);
				if (tManageAriaHidden !== false) {
					// update aria-hidden and tabindex on this item
					this.sli_setAriaHiddenState(this.$sli_items.eq(i), false); // false to show
				} else {
					// only set this item's active class
					this.$sli_items.eq(i).addClass('active');
				}
				i++;
			}
			// set focus?
			if (tSetFocus) {
				//console.log('set focus: ', (this.sli_numColumns * this.sli_activePage), this.$sli_items.eq(this.sli_numColumns * this.sli_activePage));
				// clear pre-exisitng focus timeout
				clearTimeout(this.focusTimeout);
				// set focus when tween is complete
				this.focusTimeout = setTimeout(function () {
					self.$sli_items.eq(self.sli_numColumns * self.sli_activePage).focus();
				}, 310);
			}
		}
		this.sli_dispatchActiveEvent($('.active', this.$sli_slidesHolder), tExternallyTriggered);

		// make sure arrows are showing if appropriate
		this.sli_showArrows();
		this.sli_showIndicators();
	}

	/**
	 * 
	 */
	sli_moveItems(animate) {
		//console.log('[SliderBaseView].sli_moveItems: ', animate);
		// require enabled
		if (!this.sli_getEnabled()) { return; }

		animate = (typeof animate !== 'undefined') ? animate : true;
		var self = this;

		if (animate) {
			// tween items
			gsap.to(this.sli_slidesHolderObj.slidesHolder, 0.3, { x: this.sli_slidesHolderObj.dest });
			// update lazyLoader after animation, because images outside visible area won't be loaded
			setTimeout(function () {
				// make sure images are loaded
				ProjectUtil.lazyLoader.update();
				// handle looping
				if (self.sli_config.looping) {
					// if active page is greater than the last original item's index / numColumns
					if (self.sli_activePage > Math.floor(self.sli_lastItemIndex / self.sli_numColumns)) {
						// when the page has wrapped around to the right, reset to first page
						// reset page to page 0 with no transition
						self.sli_activePage = 0;
						//console.log('[SliderBaseView].sli_moveItems - calling sli_setDestPositions 1');
						self.sli_setDestPositions();
						self.sli_moveItems(false);
					} else if (self.sli_activePage < 0) {
						// when the page has wrapped around to the left, reset to last page
						// reset page to last page with no transition
						self.sli_activePage = Math.floor(self.sli_lastItemIndex / self.sli_numColumns);
						//console.log('[SliderBaseView].sli_moveItems - calling sli_setDestPositions 2');
						self.sli_setDestPositions();
						self.sli_moveItems(false);
					}
				}
				// dispatch new 'active' item
				self.sli_dispatchEvent('updateSlideComplete', { id: self.cid, activePage: self.sli_activePage, namespace: self.sli_config.namespace });
			}, 300);
			self.sli_dispatchEvent('updateSlideStart', { id: self.cid, activePage: self.sli_activePage, namespace: self.sli_config.namespace });
		} else {
			// move items immediately
			gsap.killTweensOf(this.sli_slidesHolder);
			gsap.set(this.sli_slidesHolderObj.slidesHolder, { x: this.sli_slidesHolderObj.dest });
			// dispatch both start and end events since there is no animation
			self.sli_dispatchEvent('updateSlideStart', { id: self.id, activePage: self.sli_activePage, namespace: self.sli_config.namespace });
			self.sli_dispatchEvent('updateSlideComplete', { id: self.id, activePage: self.sli_activePage, namespace: self.sli_config.namespace });
		}
	}

	/**
	 * 
	 */
	sli_showArrows() {
		if (this.sli_getShowArrows()) {
			if (this.sli_config.looping) {
				// looping, always show both arrows
				gsap.to(this.$sli_prevBtn, 0.3, { autoAlpha: 1, display: 'block' });
				gsap.to(this.$sli_nextBtn, 0.3, { autoAlpha: 1, display: 'block' });
			} else {
				// not looping - hide arrows at edges
				//console.log('[Backbone.slider].sli_showArrows: ', this.sli_activePage, this.sli_totalPages);
				// show prev arrow?
				if (this.sli_activePage <= 0) {
					this.sli_activePage = 0;
					gsap.to(this.$sli_prevBtn, 0.3, { autoAlpha: 0, display: 'none' });
				} else {
					gsap.to(this.$sli_prevBtn, 0.3, { autoAlpha: 1, display: 'block' });
				}

				// show next arrow?
				if (this.sli_activePage >= this.sli_totalPages - 1) {
					this.sli_activePage = this.sli_totalPages - 1;
					gsap.to(this.$sli_nextBtn, 0.3, { autoAlpha: 0, display: 'none' });
				} else {
					gsap.to(this.$sli_nextBtn, 0.3, { autoAlpha: 1, display: 'block' });
				}
			}

		} else {
			// not showing arrows - clear inline display rules
			gsap.to(this.$sli_prevBtn, 0.3, { autoAlpha: 0, display: 'none' });
			gsap.to(this.$sli_nextBtn, 0.3, { autoAlpha: 0, display: 'none' });
		}
	}

	/**
	 * 
	 */
	sli_showIndicators() {
		if (this.sli_getShowIndicators()) {
			// clear active state
			this.$sli_indicators.removeClass('active');
			// set active state on new indicator
			this.$sli_indicators.eq(this.sli_activePage).addClass('active');
		}
	}

	/**
	 * 
	 */
	sli_handleLeftBtnClick(e) {
		// require enabled
		if (!this.sli_getEnabled()) { return; }

		if (e) {
			e.preventDefault();
		}

		//console.log('[SliderBaseView].sli_handleLeftBtnClick: ', this.sli_activePage, this.sli_totalPages, this.sli_config.looping, this.sli_config.namespace);
		if (this.sli_config.looping) {
			this.sli_activePage -= 1;
			//console.log('[SliderBaseView]sli_handleLeftBtnClick - calling sli_setDestPositions 1');
			this.sli_setDestPositions(false, true);
			this.sli_moveItems();
			this.sli_resetTimer();
		} else {
			//move right
			this.sli_activePage -= 1;
			if (this.sli_activePage <= 0) {
				this.sli_activePage = 0;
				gsap.to(this.$sli_prevBtn, 0.3, { autoAlpha: 0, display: 'none' });
			}
			//console.log('[SliderBaseView].sli_handleLeftBtnClick - calling sli_setDestPositions 2');
			this.sli_setDestPositions(false, true);
			this.sli_moveItems();
			if (this.sli_getShowArrows()) {
				gsap.to(this.$sli_nextBtn, 0.3, { autoAlpha: 1, display: 'block' });
			}
			this.sli_resetTimer();
		}
	}

	/**
	 * 
	 */
	sli_handleRightBtnClick(e, forceLoop) {
		// require enabled
		if (!this.sli_getEnabled()) { return; }

		if (e) {
			e.preventDefault();
		}

		// default forceLoop to false
		forceLoop = (typeof forceLoop !== 'undefined') ? forceLoop : false;

		this.sli_activePage++;
		if (this.sli_config.looping) {
			//console.log('[SliderBaseView].sli_handleRightBtnClick - calling sli_setDestPositions 1');
			this.sli_setDestPositions(false, true);
			this.sli_moveItems();
			this.sli_resetTimer();
		} else {
			//move left
			if (forceLoop && this.sli_activePage > this.sli_totalPages - 1) {
				//console.log('[SliderBaseView].this.sli_activePage: ', this.sli_activePage);
				//console.log('[SliderBaseView].this.sli_totalPages - 1: ', (this.sli_totalPages - 1));
				// not looping (cleanly), force back to first position
				this.sli_activePage = 0;
			} else if (this.sli_activePage >= this.sli_totalPages - 1) {
				this.sli_activePage = this.sli_totalPages - 1;
				gsap.to(this.$sli_nextBtn, 0.3, { autoAlpha: 0, display: 'none' });
			}
			//console.log('[SliderBaseView].sli_handleRightBtnClick - calling sli_setDestPositions 2');
			this.sli_setDestPositions(false, true);
			this.sli_moveItems();
			if (this.sli_getShowArrows()) {
				gsap.to(this.$sli_prevBtn, 0.3, { autoAlpha: 1, display: 'block' });
			}
			this.sli_resetTimer();
		}
	}

	/**
	 * -----------------
	 *     SWIPING
	 * -----------------
	 */

	/**
	 * 
	 */
	sli_swipeDirection() {
		var xDist,
			yDist,
			r,
			swipeAngle;

		xDist = this.sli_touchObject.startX - this.sli_touchObject.curX;
		yDist = this.sli_touchObject.startY - this.sli_touchObject.curY;
		r = Math.atan2(yDist, xDist);

		swipeAngle = Math.round(r * 180 / Math.PI);
		if (swipeAngle < 0) {
			swipeAngle = 360 - Math.abs(swipeAngle);
		}

		if ((swipeAngle <= 45) && (swipeAngle >= 0)) {
			return 'left';
		}
		if ((swipeAngle <= 360) && (swipeAngle >= 315)) {
			return 'left';
		}
		if ((swipeAngle >= 135) && (swipeAngle <= 225)) {
			return 'right';
		}

		return 'left';
	}

	/**
	 * 
	 */
	sli_swipeStart(e) {
		//console.log('[SliderBaseView].sli_swipeStart');
		if (!this.sli_config.useSwipe) { return; }
		if (!this.sli_getDragEnabled()) { return; }

		var touches;
		// stop tweens
		gsap.killTweensOf(this.sli_slidesHolder);

		// don't handle multitouch events or swipe when there isn't a hidden item
		if (this.sli_touchObject.fingerCount !== 1 || this.sli_totalItems <= this.sli_numColumns) {
			this.sli_touchObject = {};
			this.sli_touchObject.swipeLength = 0;
			return false;
		}
		// get the touch
		if (e.originalEvent !== undefined && e.originalEvent.touches !== undefined) {
			touches = e.originalEvent.touches[0];
		}

		// define touch object
		this.sli_touchObject.startX = this.sli_touchObject.curX = touches !== undefined ? touches.pageX : e.clientX;
		this.sli_touchObject.startY = this.sli_touchObject.curY = touches !== undefined ? touches.pageY : e.clientY;

		// set draging to true
		this.dragging = true;

		// dispatch swipeStart event
		this.pubSub.trigger('swipeStart', this.sli_config.namespace);
	}

	/**
	 * 
	 */
	sli_swipeMove(e) {
		//console.log('[SliderBaseView].sli_swipeMove');
		if (!this.sli_config.useSwipe) { return; }
		if (!this.sli_getDragEnabled()) { return; }

		var self = this,
			sli_swipeDirection,
			swipeLength,
			positionOffset,
			touches,
			//leftPadding,
			itemWidth;

		// get touches
		touches = e.originalEvent !== undefined ? e.originalEvent.touches : null;

		// make sure we should proceed
		if (!this.dragging || touches && touches.length !== 1) {
			return false;
		}

		// update touchObject
		this.sli_touchObject.curX = touches !== undefined ? touches[0].pageX : e.clientX;
		this.sli_touchObject.curY = touches !== undefined ? touches[0].pageY : e.clientY;
		this.sli_touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(this.sli_touchObject.curX - this.sli_touchObject.startX, 2)));

		//get sli_swipeDirection
		sli_swipeDirection = this.sli_swipeDirection();

		if (e.originalEvent !== undefined && this.sli_touchObject.swipeLength > 4) {
			e.preventDefault();
		}

		positionOffset = -1 * (this.sli_touchObject.curX > this.sli_touchObject.startX ? 1 : -1);

		swipeLength = this.sli_touchObject.swipeLength;

		this.sli_touchObject.edgeHit = false;

		if ((this.currentSlide === 0 && sli_swipeDirection === 'right') || (this.currentSlide >= this.sli_totalItems && sli_swipeDirection === 'left')) {
			swipeLength = this.sli_touchObject.swipeLength * 0.35; //this.options.edgeFriction;
			this.sli_touchObject.edgeHit = true;
		}

		this.swipeLeft = swipeLength * positionOffset;
		// update positions
		itemWidth = this.$sli_firstItem.outerWidth();

		if (this.sli_useSlider()) {
			var prevDestX = this.sli_slidesHolderObj.dest;
			gsap.set(this.sli_slidesHolder, { x: prevDestX - self.swipeLeft });
		}
	}

	/**
	 * 
	 */
	sli_swipeEnd() {
		//console.log('[SliderBaseView].sli_swipeEnd');
		if (!this.sli_config.useSwipe) { return; }
		if (!this.sli_getDragEnabled()) { return; }
		if (this.sli_touchObject.swipeLength === undefined) { return; }

		var direction;

		this.dragging = false;
		this.interrupted = false;
		this.shouldClick = (this.sli_touchObject.swipeLength > 10) ? false : true;
		//console.log('[SliderBaseView].sli_swipeEnd - this.shouldClick: ', this.shouldClick, this.sli_touchObject);
		if (this.sli_touchObject.curX === undefined) {
			return false;
		}

		if (this.sli_touchObject.swipeLength >= this.sli_touchObject.minSwipe) {

			direction = this.sli_swipeDirection();
			switch (direction) {

				case 'left':
					// shift left
					this.sli_handleRightBtnClick();
					break;

				case 'right':
					// shift right
					this.sli_handleLeftBtnClick();
					break;

			}

			this.sli_touchObject = {};
			// dispatch swipeEnd event
			this.pubSub.trigger('swipeEnd', this.sli_config.namespace);

		} else {

			if (this.sli_touchObject.startX !== this.sli_touchObject.curX) {
				this.sli_touchObject = {};
				//console.log('[SliderBaseView].sli_swipeEnd - calling sli_setDestPositions');
				this.sli_setDestPositions();
				this.sli_moveItems();
				// since items aren't moving, dispatch cancel event
				this.pubSub.trigger('swipeCancel', this.sli_config.namespace);
			}

		}
	}

	/**
	 * 
	 */
	sli_handleSwipeAction(e) {
		// require enabled
		if (!this.sli_getEnabled()) { return; }
		if (!this.sli_getDragEnabled()) { return; }

		this.sli_touchObject.fingerCount = e.originalEvent && e.originalEvent.touches !== undefined ? e.originalEvent.touches.length : 1;
		this.sli_touchObject.minSwipe = this.$el.width() / 5;

		switch (e.type) {

			case 'mousedown':
			case 'touchstart':
				this.sli_swipeStart(e);
				break;

			case 'mousemove':
			case 'touchmove':
				this.sli_swipeMove(e);
				break;

			case 'mouseup':
			case 'touchend':
			case 'mouseleave':
			case 'touchcancel':
				this.sli_swipeEnd();
				break;

			// prevent FF link dragging
			case 'dragstart':
				//console.log('[SliderBaseView].dragstart');
				e.preventDefault();
				break;
		}
	}

	/**
	 * 
	 */
	sli_handleSlidesHolderClick(e) {
		// require enabled
		if (!this.sli_getEnabled()) { return; }

		if (this.shouldClick === false) {
			e.stopImmediatePropagation();
			e.stopPropagation();
			e.preventDefault();
		}
	}

	/**
	 * 
	 */
	sli_handleIndicatorClick(e) {
		//console.log('[SliderBaseView].sli_handleIndicatorClick: ', e);
		// require enabled
		if (!this.sli_getEnabled()) { return; }

		var tIndex = $(e.target).data('index');
		if (!isNaN(tIndex)) {
			this.sli_activePage = tIndex;
			if (this.sli_activePage <= 0) {
				this.sli_activePage = 0;
				gsap.to(this.$sli_prevBtn, 0.3, { autoAlpha: 0, display: 'none' });
			}
			//console.log('[SliderBaseView].sli_handleIndicatorClick - calling sli_setDestPositions');
			this.sli_setDestPositions(false, true);
			this.sli_moveItems();
			if (this.sli_getShowArrows()) {
				gsap.to(this.$sli_nextBtn, 0.3, { autoAlpha: 1, display: 'block' });
			}
			this.sli_resetTimer();
		}
	}

	/**
	 * Handle Focus updates - likely screen readers
	 */
	/*sli_handleSliderItemFocus(e) {
		// require focus trigger capability
		if (!this.sli_getHandleFocus()) { return; }
		//console.log('[SliderBaseView].sli_handleSliderItemFocus: ', e);
		// get the index of the .slider-item in this.$sli_items
		var tIndex = this.$sli_items.index($(e.currentTarget));
		//console.log('[SliderBaseView].sli_handleSliderItemFocus: ', tIndex, e);
		this.setActiveSlide(tIndex, true);

	}*/
}

export default BackboneSlider;
